import {
  createStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  WithStyles,
  withStyles,
  Divider,
  DialogActions,
  Button,
  Switch,
  Theme,
  capitalize,
} from "@material-ui/core";
import * as React from "react";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { ConfigurationService } from "../services/ConfigurationService";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import PermDataSettingIcon from "@material-ui/icons/PermDataSetting";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import AddAccessConfigurationsDialog from "./AddAccessConfigurationsDialog";
import AssignPermissionDialog from "./AssignPermissionDialog";
import { getRoles, ROLES } from "../constants/constants";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";

export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const CustomSwitch = withStyles({
  switchBase: {
    color: "orange",
    "&$checked": {
      color: "orange",
    },
    "&$checked + $track": {
      backgroundColor: "orange",
    },
  },
  checked: {},
  track: {
    backgroundColor: "grey",
  },
})(Switch);
const styles = (theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        borderBottom: "unset",
      },
    },
    button: {
      margin: theme.spacing(1),
    },
  });
interface Props extends WithStyles<typeof styles> {
  dialogTitle: any;
  open: any;
  handleClose: any;
}

class AccessConfigurationsDialog extends React.Component<Props> {
  state = {
    accessData: [],
    openAddAccessConfigDialog: false,
    openAssignPermissionDialog: false,
    selectedRow: { role: "", static: new Array<any>() },
    open: false
  };
  componentDidMount = () => {
    this.getAccess();
  };
  componentDidUpdate = () => { };
  getAccess = () => {
    this.setState({
      isLoading: true,
    });
    let configurationService: ConfigurationService = new ConfigurationService();
    configurationService.getAccess().then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.data) {
        if (this.state.selectedRow.role) {
          this.setState(
            {
              accessData: resp.data,
            },
            () => {
              this.setState({
                openAssignPermissionDialog: true,
              });
            }
          );
        } else {
          this.setState({
            accessData: resp.data,
          });
        }
      }
    });
  };
  updateAccess = (accessRules: any) => {
    this.setState({
      isLoading: true,
    });
    let configurationService: ConfigurationService = new ConfigurationService();
    configurationService.updateAccess(accessRules).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.updated) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Updated Successfully",
        });
        this.setState(
          {
            selectedRow: { role: "", static: new Array<any>() },
          },
          () => {
            this.getAccess();
          }
        );
      }
    });
  };
  createData = (
    name: string,
    calories: number,
    fat: number,
    carbs: number,
    protein: number,
    price: number
  ) => {
    return {
      name,
      calories,
      fat,
      carbs,
      protein,
      price,
      history: [
        { date: "2020-01-05", customerId: "11091700", amount: 3 },
        { date: "2020-01-02", customerId: "Anonymous", amount: 1 },
      ],
    };
  };
  handleOnSwitch = (event: any, index: any, row: any) => {
    let selectedAccessItem = row.static[index];
    selectedAccessItem.enabled = event.target.checked;
    this.updateAccess(row);
  };
  handleOnDelete = (index: any, row: any) => {
    row.static.splice(index, 1);
    // row.static = selectedAccessItem;
    this.updateAccess(row);
  };
  CustomerTableRow = (mProps: any) => {
    const { classes } = this.props;
    const { open } = this.state;
    const { row } = mProps;
    // const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow
          className={classes.root}
          style={{ marginLeft: 20, marginRight: 20 }}
        >
          <TableCell align={"left"}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => this.setState(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell align={"right"}>{row.role}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h6">{"Access Fields"}</Typography>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      this.setState(
                        {
                          selectedRow: row,
                        },
                        () => {
                          this.getAccess();
                        }
                      );
                    }}
                    className={classes.button}
                    startIcon={<SwapHorizIcon />}
                  >
                    Assign
                  </Button>
                </div>
                <Table size="small" padding={"none"} aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Field</TableCell>
                      <TableCell>Permission</TableCell>
                      <TableCell>Control</TableCell>
                      <TableCell align={"right"}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.static
                      .sort((a: any, b: any) =>
                        a.permission.split(":")[0] > b.permission.split(":")[0]
                          ? 1
                          : -1
                      )
                      .map((staticItem: any, index: any) => (
                        <TableRow key={`item-static-${index.toString()}`}>
                          <TableCell>
                            {capitalize(staticItem.permission.split(":")[0])}
                          </TableCell>
                          <TableCell>
                            {capitalize(staticItem.permission.split(":")[1])}
                          </TableCell>
                          <TableCell>
                            <CustomSwitch
                              checked={staticItem.enabled}
                              disabled={
                                row.role === ROLES.KRODAC_ADMIN ? true : false
                              }
                              onChange={(event: any) =>
                                this.handleOnSwitch(event, index, row)
                              }
                              style={{
                                color: staticItem.enabled ? "#f96500" : "white",
                              }}
                              name="checked"
                            />
                          </TableCell>
                          <TableCell align="right">
                            <IconButton
                              aria-label="delete"
                              disabled={
                                row.role === ROLES.KRODAC_ADMIN ? true : false
                              }
                              onClick={() => this.handleOnDelete(index, row)}
                            >
                              <RemoveCircleOutlineIcon fontSize="default" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  handleClose = () => {
    this.setState({
      openAddAccessConfigDialog: false,
      openAssignPermissionDialog: false,
    });
  };

  handleOnSubmit = (otherAccessRules?: any) => {
    if (otherAccessRules) {
      otherAccessRules.map((otherAccessRuleItem: any) => {
        this.updateAccess(otherAccessRuleItem);
        return null;
      });
    }
    this.setState(
      {
        selectedRow: { role: "", static: new Array<any>() },
      },
      () => {
        this.getAccess();
      }
    );
  };

  handleOnAssign = (selectedPermission: any) => {
    let selectedRow = this.state.selectedRow;
    selectedRow.static.push({ permission: selectedPermission, enabled: false });
    this.updateAccess(selectedRow);
  };

  renderAccessConfigurationDialog = () => {
    return (
      <AddAccessConfigurationsDialog
        open={this.state.openAddAccessConfigDialog}
        dialogTitle={"Add Access Configurations"}
        handleOnSubmit={this.handleOnSubmit}
        handleClose={this.handleClose}
      />
    );
  };

  renderAssignPermissionDialog = () => {
    let accessRules = getRoles(ROLES.KRODAC_ADMIN, this.state.accessData);
    return (
      <AssignPermissionDialog
        open={this.state.openAssignPermissionDialog}
        dialogTitle={"Assign Permission"}
        accessRules={
          accessRules && accessRules.static
            ? accessRules.static.sort((a: any, b: any) =>
              a.permission.split(":")[0] > b.permission.split(":")[0] ? 1 : -1
            )
            : []
        }
        selectedAccessRules={
          this.state.selectedRow && this.state.selectedRow.static
            ? this.state.selectedRow.static.sort((a: any, b: any) =>
              a.permission.split(":")[0] > b.permission.split(":")[0] ? 1 : -1
            )
            : []
        }
        handleOnAssign={this.handleOnAssign}
        onClose={this.handleClose}
      />
    );
  };

  render() {
    const { dialogTitle, classes, open, handleClose } = this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          maxWidth={"lg"}
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-slide-title">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">{dialogTitle}</Typography>
              <Button
                variant="outlined"
                onClick={() => {
                  this.setState({
                    openAddAccessConfigDialog: true,
                  });
                }}
                className={classes.button}
                startIcon={<PermDataSettingIcon />}
              >
                Configurations
              </Button>
            </div>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <TableContainer>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell align={"left"}>Filter</TableCell>
                    <TableCell align={"right"}>Roles</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.accessData.map((accessItem: any, index: any) => {
                    return (
                      <this.CustomerTableRow
                        key={index.toString()}
                        row={accessItem}
                      />
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <div
              style={{
                display: "flex",
                marginTop: 10,
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography variant="caption">
                {"Press reload for changes to take effect."}
              </Typography>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleClose()}>Close</Button>
            <Button onClick={() => window.location.reload()}>Reload</Button>
          </DialogActions>
        </Dialog>
        {this.renderAccessConfigurationDialog()}
        {this.renderAssignPermissionDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AccessConfigurationsDialog);
